import { createContext, use } from 'react';

import type { Logger } from '../lib/logger.config';

export type LoggerContextType = {
    logger: Logger;
};

export const LoggerContext = createContext<LoggerContextType | null>(null);

export function useLogger() {
    const context = use(LoggerContext);

    if (!context) {
        throw new Error('useLogger must be used within a LoggerProvider');
    }

    return context;
}
